export default "__VITE_ASSET__TWuRWL9a__"